// extracted by mini-css-extract-plugin
module.exports = {"container":"engliseVersuion_container__1oScx","title":"engliseVersuion_title__3uNWb","indent":"engliseVersuion_indent___B8wq","titleSpan":"engliseVersuion_titleSpan__10JI_"};